import { ContactEventRegistry, OnceOptions } from './event_registry';
export class ContactEventHub {
    constructor(eventApi) {
        this.registry = new ContactEventRegistry(eventApi);
    }
    onSubAccountAdded(handler) {
        this.registry.on('SubAccountAdded', handler);
    }
    onSubAccountDeleted(handler) {
        this.registry.on('SubAccountDeleted', handler);
    }
    onSubAccountLoginExpired(handler) {
        this.registry.on('SubAccountLoginExpired', handler);
    }
    onDetectContactException(handler, opts) {
        const eventName = process.env.BUILD_ISELECTRON ? 'detectContactException' : 'detectContactExceptionInWeb';
        this.registry.on(eventName, handler, opts);
    }
    onContactNotify(handler) {
        this.registry.on('contactNotify', handler);
    }
    onContactOrgNotify(handler) {
        this.registry.on('contactOrgNotify', handler);
    }
    onImTeamEvents(handler) {
        this.registry.on('imTeamEvents', handler);
    }
    waitForOrgPathlistReady(account, opts) {
        var _a;
        return this.registry.once('coreOrgPathlistReady', Object.assign(Object.assign({}, opts), { timeout: (_a = opts === null || opts === void 0 ? void 0 : opts.timeout) !== null && _a !== void 0 ? _a : 5000, _account: account }));
    }
    waitForOrgContactReady(account, opts) {
        var _a;
        return this.registry.once('subCoreOrgContactReady', Object.assign(Object.assign({}, opts), { timeout: (_a = opts === null || opts === void 0 ? void 0 : opts.timeout) !== null && _a !== void 0 ? _a : 5000, _account: account }));
    }
    waitForUserStoreChange(account, opts) {
        var _a;
        return this.registry.once('storeUserChangeEvent', Object.assign(Object.assign({}, opts), { timeout: (_a = opts === null || opts === void 0 ? void 0 : opts.timeout) !== null && _a !== void 0 ? _a : 2000, _account: account }));
    }
}
